<template>
	<div class="vehicle-list">
        <div class="vehicles-list__body">
            <label class="vehicles-list__item" v-for="(vehicle, index) in savedvehicles" :key="index">
                <span class="vehicles-list__item-radio input-radio">
                    <span class="input-radio__body">
                        <input class="input-radio__input" name="header-vehicle" type="radio" v-model="selectedvehicle" :value="index" />
                        <span class="input-radio__circle"> </span>
                    </span>
                </span>
                <span class="vehicles-list__item-info">
                    <span class="vehicles-list__item-name">
                        {{ vehicle.year }} {{ vehicle.makedesc }} {{ vehicle.modeldesc }}
                    </span>
                    <span class="vehicles-list__item-details">
                        {{ vehicle.enginedesc }}
                    </span>
                </span>
            </label> 
        </div>  
    </div>
    <div class="vehicle-picker__actions">
        <button type="button" class="btn btn-secondary btn-sm" data-to-panel="form" @click="$emit('cancelSavedVehicles')">
            Cancel
        </button>
        <button type="button" class="btn btn-primary btn-sm" data-to-panel="form" @click="searchParts()">
            New Search
        </button>
    </div>

</template>

<script>
import { mapGetters } from 'vuex';
import axiosvl from "../../../axios/axios-vl.js";

export default {
	data() {
		return {
            selectedvehicle: 0,
			savedvehicles: []
		}
	},
    emits: [
        'cancelSavedVehicles',
        'closePanel'
    ],
    computed: {
        ...mapGetters([
            'userIsAuthenticated',
            "appInitialiazed"
        ]),
        ...mapGetters("vehicle", [
            'newsavedvehicleadded'
        ])
    },
    watch: {
        userIsAuthenticated(newVal) {
            if (newVal) {
                this.getSavedVehicles();
            } else {
                this.savedvehicles = [];
            }
        },
        newsavedvehicleadded(newVal) {
            if (newVal) {
                this.getSavedVehicles();
                this.$store.dispatch("vehicle/setNewSavedVehicleAdded", false);
            }
        },
        appInitialiazed(newVal) {
            if(newVal == true){
                this.getSavedVehicles();
            }
        }
    },
	methods: {
		getSavedVehicles() {
            this.savedvehicles = [];
            const catpn = this.$store.getters['storeConfigID'];
            axiosvl.post(this.$store.getters['api/get_saved_vehicle_uri'], {
                "webroutine": {
                "context": {
                    "session-key-method": "hidden"
                },
                "fields": {
                    "EHCUST": {"value": this.$store.getters.customer},
                    "CATPN": {"value": catpn},
                }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields

                if (fields.RESULTCOD.value === 'OK') {
                    const results = [];

                    for (const key in response.data.webroutine.lists.LASTCARSD.entries) {
                        const obj = response.data.webroutine.lists.LASTCARSD.entries[key];
                        results.push({
                            year: obj.QYEAR,
                            make: obj.QMAKE,
                            makedesc: obj.QMKDSC,
                            model: obj.QMODEL,
                            modeldesc: obj.QMODSC,
                            engine: obj.QCARCD,
                            enginedesc: obj.QENDSC,
                        });
                    }
                    this.savedvehicles = results;

                }
            })
            .catch((error) => {
                console.error('error - ' + error);
            });
        },
        searchParts() {
            let selvehicle = this.savedvehicles[this.selectedvehicle];
            if (this.$store.getters['storeCatalog'] === 'WHI') {
                this.$store.dispatch("vehicle/setSelectedVehicle", { "selectedvehicle": 0 });
                this.$store.dispatch("vehicle/setSelectedYear", { "selectedyear": selvehicle.year });
                this.$store.dispatch("vehicle/setSelectedMake", { "selectedmake": selvehicle.make, "desc": selvehicle.makedesc });
                this.$store.dispatch("vehicle/setSelectedModel", { "selectedmodel": selvehicle.model, "desc": selvehicle.modeldesc });
                this.$store.dispatch("vehicle/setSelectedEngine", { "selectedengine": selvehicle.engine, "desc": selvehicle.enginedesc });
            }

            if (this.$store.getters['storeCatalog'] === 'PARTSLINK') {
                this.$store.dispatch("vehicle/setSelectedVehicle", { "selectedvehicle": 0 });
                this.$store.dispatch("vehicle/setSelectedYear", { "selectedyear": selvehicle.year });
                this.$store.dispatch("vehicle/setSelectedMake", { "selectedmake": selvehicle.makedesc, "desc": selvehicle.makedesc });
                this.$store.dispatch("vehicle/setSelectedModel", { "selectedmodel": selvehicle.modeldesc, "desc": selvehicle.modeldesc });
            }

            this.$emit('closePanel');
            this.$router.push("/select-parts-drilldown");
        }
	},
    created() {
        this.savedvehicles = [];
        if(this.appInitialiazed == true){
            this.getSavedVehicles();
        }
    }
}
</script>